import React from "react"
import "./QuestionACT.css"
import "./InformationalContent.css"

/**
 * Informational content used right before the questions and has the similar layout.
 * @returns 
 */
export default function InformationalContent(props) {
    let {currentInformationalIndex, section, allowBookmark, disableBack, disableNext, onBookmark, onBack, onNext} = props
    let showInformation

    if (currentInformationalIndex < 1) {
        showInformation = true
    }
    else {
        showInformation = false
    }

    let text = showInformation ? "Information": "Instructions"
    let sectionalInfo

    switch(section) {
        case "englishAnswers":
            sectionalInfo = showInformation ? <InformationEnglish /> : <InstructionsEnglish/>
            break

        case "mathAnswers":
            sectionalInfo = showInformation ? <InformationMath /> : <InstructionsMath/>
            break

        case "readingAnswers":
            sectionalInfo = showInformation ? <InformationReading /> : <InstructionsReading/> 
            break

        case "scienceAnswers":
            sectionalInfo = showInformation ? <InformationScience /> : <InstructionsScience/>
            break
    }

    return (
        <div className="act-main-container informational-container">
            <div className="act-question">
                <InformationalHeader text={text} allowBookmark={allowBookmark} onBookmark={onBookmark}/>
                <div className="act-question-content informational-content">
                    {sectionalInfo}
                </div>
                <div className="act-bottom-navigation">
                    <button className="eact-btn eact-btn--prev" disabled={disableBack} onClick={onBack}>
                        <span aria-hidden="true" className="eact-icon-chevron-left"></span>
                        <span className="show-sm">Prev</span>
                    </button>
                    <button className="eact-btn eact-btn--next" disabled={disableNext} onClick={onNext}>
                        <span className="show-sm">Next</span>
                        <span aria-hidden="true" className="eact-icon-chevron-right"></span>
                    </button>
                </div>
            </div>
        </div>
    )
}

//--- Helpers ---

function InformationalHeader(props) {
    let { text, allowBookmark, onBookmark } = props

    return (
        <div className="act-info-bar">
            <div className="eact-page-landmark">
                {text}
            </div>
            { allowBookmark &&
                <div>
                    <InformationalBookmark onBookmark={onBookmark}/>
                </div>
            }
        </div>
    )
}

function InformationalBookmark(props) {
    let { onBookmark, bookmarked } = props
    let imgUrl = `/assets/images/icons/v2/${!bookmarked ? "ico-bookmark.svg" : "ico-bookmark-bright.svg"}`

    return (
        <button className="eact-btn act-bookmark-btn" onClick={onBookmark}>
            <span className="act-bookmark-icon">
                <svg width="14" height="19" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0H12C12.7956 0 13.5587 0.31607 14.1213 0.87868C14.6839 1.44129 15 2.20435 15 3V20.25C15 20.5453 14.8267 20.8132 14.5572 20.9342C14.2878 21.0552 13.9725 21.0068 13.7517 20.8106L7.5 15.2535L1.24827 20.8106C1.02753 21.0068 0.712183 21.0552 0.442758 20.9342C0.173333 20.8132 0 20.5453 0 20.25V3C0 2.20435 0.316071 1.44129 0.87868 0.87868Z" fill="currentColor"/>
                </svg>
            </span>
            <span className={`act-bookmark-label bookmarked`}>
                FLAG
            </span>
        </button>
    )
}

//--- Information ---
function InformationEnglish(props) {
    return (
        <div>
            <h2>English Test Directions</h2>
            <p>The next screen in this section contains instructions about the English test. That screen is not part of the scored questions. You can return to the instructions at any time by selecting the <b>Index</b> icon and then selecting <b>Instructions</b>.</p>
            <p>You may use scratch paper on this test. You will hand that to the room supervisor at the end of testing.</p>
            <p>The timer will start when you select <b>Next</b> to begin the English test.</p>
        </div>
    )
}

function InformationMath(props) {
    return (
        <div>
            <h2>Mathematics Test Directions</h2>

            <p>The next screen in this section contains instructions about the Mathematics test. The screen is not part of the scored questions. You can return to the instructions at any time by selecting the <b>Index</b> icon and then selecting the <b>Instructions</b>.</p>
            <p>You are permitted to use a calculator on this test, and you may get it out now. Some types of calculators are prohibited. For example, you may not use any version of the TI-89. You are responsible for knowing if your calculator is permitted. Testing staff will check your calculator periodically during the test. If you use a prohibited calculator, you will be dismissed, and your tests will not be scored.</p>
            <p>You are responsible for making sure your calculator is working properly. You will not be provided with backup batteries or a replacement calculator. A calculator is provided on-screen as part of this test.</p>
            <p>Do not share your calculator with another examinee. Do not connect your calculator in any way to the computer. </p>
            <p>If you need to use your backup calculator, raise your hand and testing staff will check it. You may have only one calculator on your workstation or in operation at a time. If you did not bring a backup calculator and yours malfunctions, continue testing.</p>
            <p>You may use scratch paper on this test. You will hand that to the room supervisor at the end of testing.</p>
            <p>The timer will start when you select <b>Next</b> to begin the Mathematics test.</p>
        </div>
    )
}

function InformationReading(props) {
    return (
        <div>
            <h2>Reading Test Directions</h2>

            <p>
                The next section in this section contains instructions about the Reading test. The screen is not part of the scored questions. You can return to the instructions at any time by selecting the <b>Index</b> icon and then selecting the <b>Instuctions</b>.
            </p>
            <p>
                You may use scratch paper on this test. You wil hand that to the room supervisor at the end of testing.
            </p>
            <p>
                The timer will start when you select <b>Next</b> to begin the Reading test.
            </p>
        </div>
    )
}

function InformationScience(props) {
    return (
        <div>
            <h2>Science Test Directions</h2>

            <p>
                The next section in this section contains instructions about the Science test. The screen is not part of the scored questions. You can return to the instructions at any time by selecting the <b>Index</b> icon and then selecting the <b>Instuctions</b>.
            </p>
            <p>
                You may use scratch paper on this test. You wil hand that to the room supervisor at the end of testing.
            </p>
            <p>
                The timer will start when you select <b>Next</b> to begin the Science test.
            </p>
        </div>
    )
}

//--- Instructions ---
function InstructionsEnglish(props) {
    return (
        <div>
            <p>English Test - 50 questions</p>
            <p>
                In the passages that follow, certain words and phrases are underlined and highlighted. 
                On the right-hand side of the screen, you will find alternatives to the underlined and 
                highlighted text. You are to choose the best answer to each question. If you think the 
                original version is best, choose “<b>No Change</b>.”
            </p>
            <p>
                You will also find questions about a section of the passage, or about the passage as a whole. 
                These questions do not refer to an underlined and highlighted portion of the passage, but rather
                refer to a letter or letters, a number or numbers, or an asterisk within square brackets [ ].
            </p>
            <p>
                For each question, choose the alternative you consider best and select your answer. Read each
                passage through once before you begin to answer the questions that accompany the passage. For many
                of the questions, you must read several sentences beyond the question to determine the answer. Be
                sure that you have read far enough ahead each time before you choose an alternative.
            </p>
            <p>
                Select the <b>Next</b> button to proceed.
            </p>
        </div>
    )
}

function InstructionsMath(props) {
    return (
        <div>
            <p>Mathematics Test - 45 questions</p>

            <p>Solve each problem, choose the correct answer, and select your answer.</p>

            <p>Do not linger over problems that take too much time. Solve as many as you can. You may return to problems in the time you have left for this test.</p>

            <p>You are permitted to use an approved calculator on this test. You may use a calculator for any problems you choose, but some of the problems may best be done without using a calculator.</p>

            <p>Note: Unless otherwise stated, all of the following should be assumed.</p>
            <ol>
                <li className="mb-2">Illustrative figures are <b>not</b> necessarily drawn to scale.</li>
                <li className="mb-2">Geometric figures lie in a plane.</li>
                <li className="mb-2">The word “line” indicates a straight line.</li>
                <li className="mb-2">The word “average” indicates arithmetic mean.</li>
            </ol>
        </div>
    )
}

function InstructionsReading(props) {
    return (
        <div>
            <p>Reading Test - 36 questions</p>
            <p>There are several passages in this test. Each passage is accompanied by several questions. (Some passages are grouped within a single scrollable window, and the corresponding questions will refer to Passage A, Passage B, or both passages.) After reading a passage, choose the best answer to each question, and select your answer. You may refer to the passages as often as necessary.</p>
            <p>Select the <b>Next</b> button to proceed.</p>
        </div>
    )
}

function InstructionsScience(props) {
    return (
        <div>
            <p>Science Test - 40 questions</p>
            <p>There are several passages in this test. Each passage is followed by several questions. After reading a passage, choose the best answer to each question, and select <b>Next</b> to record your answer. You may refer to the passages as often as necessary.</p>
            <p>You are <b>not</b> permitted to use a calculator on this test.</p>
            <p>Select the <b>Next</b> button to proceed.</p>
        </div>
    )
}

